<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Change pricing tier</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="update()">
        <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content>

  <ion-list>
    @if (pricing_tiers && pricing_tiers.length) {
      <ion-radio-group [(ngModel)]="selected_pricing_tier_id">
        @for (pricing_tier of pricing_tiers; track pricing_tier) {
          @if (pricing_tier.sellable == true) {
            <ion-item lines="full">
              <ion-radio class="primary" labelPlacement="start" value="{{ pricing_tier.id }}">{{pricing_tier.title}}</ion-radio>
            </ion-item>
          }
        }
      </ion-radio-group>
    }
  </ion-list>

</ion-content>
